const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}

/* ── LSL: external booking links (Calendly) open in a new tab ── */
window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[href*="calendly.com"]').forEach((a) => {
    a.target = '_blank';
    a.rel = 'noopener';
  });
});

/* ── LSL: "remind me" nudge under the CCP tier cards (Alex, 2026-07-11) ──
   Progressive enhancement: inserts a shortcut to the existing #rsvp signup
   form directly below the pricing tiers on /pages/cozy-corner-post.
   If this script never runs, the form is still reachable by scrolling.
   NOTE: instant jump on purpose — smooth scrolling is cancelled by other
   scroll handlers on this page (story player), so 'smooth' never arrives. */
window.addEventListener('DOMContentLoaded', () => {
  const tiers = document.querySelector('.lsl-audio__tiers');
  const rsvp = document.getElementById('rsvp');
  if (!tiers || !rsvp || document.querySelector('.lsl-audio__tiers-nudge')) return;

  const style = document.createElement('style');
  style.textContent = [
    ".lsl-audio__tiers-nudge { text-align: center; margin: 30px auto 0; max-width: 640px; }",
    ".lsl-audio__tiers-nudge-text { font-family: 'EB Garamond','Iowan Old Style',Georgia,serif; font-style: italic; font-size: clamp(17px,1.6vw,20px); color: rgba(60,47,47,0.78); margin: 0 0 4px; }",
    ".lsl-audio__tiers-nudge-link { display: inline-flex; align-items: center; font-family: 'Courier Prime','Courier New',monospace; font-size: clamp(14px,1.4vw,16px); font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; color: #b85d3a; text-decoration: none; padding: 12px 6px; min-height: 44px; border-bottom: 1.5px solid rgba(184,93,58,0.45); transition: color .2s, border-color .2s; }",
    ".lsl-audio__tiers-nudge-link:hover, .lsl-audio__tiers-nudge-link:focus-visible { color: #a94b46; border-color: #a94b46; }"
  ].join('\n');
  document.head.appendChild(style);

  const nudge = document.createElement('div');
  nudge.className = 'lsl-audio__tiers-nudge';
  const text = document.createElement('p');
  text.className = 'lsl-audio__tiers-nudge-text';
  text.textContent = "not ready to commit to either today? that's allowed.";
  const link = document.createElement('a');
  link.className = 'lsl-audio__tiers-nudge-link';
  link.href = '#rsvp';
  link.textContent = 'remind me when the season opens \u2193';
  nudge.appendChild(text);
  nudge.appendChild(link);
  tiers.insertAdjacentElement('afterend', nudge);

  link.addEventListener('click', (e) => {
    e.preventDefault();
    rsvp.scrollIntoView({ behavior: 'auto', block: 'center' });
    const email = rsvp.querySelector('input[type="email"]');
    if (email) email.focus({ preventScroll: true });
  });
});
